import i18n from '@/config/i18n'
export default {
  items: [
    {
      name: i18n.t('title.dashboard'),
      url: '/dashboard',
      icon: 'far fa-tachometer-alt'
    },
    {
      name: i18n.tc('title.models', 0),
      url: '/models',
      icon: 'far fa-file-invoice'
    },
    {
      name: i18n.tc('title.categories', 0),
      url: '/category',
      icon: 'far fa-folder',
    },
    {
      name: i18n.tc('title.profiles', 0),
      url: '/profiles',
      icon: 'far fa-h1'
    },
    {
      name: i18n.tc('title.companies', 0),
      url: '/company',
      icon: 'far fa-hospital-alt'
    },
    {
      name: i18n.t('title.documentType'),
      url: '/doctype',
      icon: 'far fa-file-code'
    },
    {
      name: i18n.t('title.codingSchema'),
      url: '/documentTypeCodingSchema',
      icon: 'far fa-archive'
    },
    {
      name: i18n.t('title.patientConstraint'),
      url: '/patientConstraint',
      icon: 'far fa-tasks'
    },
    {
      name: i18n.tc('title.ppd', 1),
      url: '/patientAndProcedureDetails',
      icon: 'far fa-user-md'
    },
    {
      name: i18n.tc('title.jaspers', 1),
      url: '/jasper',
      icon: 'far fa-file-code'
    },
    {
      name: i18n.tc('title.uploadimage', 1),
      url: '/uploadimage',
      icon: 'far fa-images'
    },
    {
      name: i18n.tc('title.sources', 1),
      url: '/sources',
      icon: 'fab fa-buffer'
    },
    {
      name: i18n.tc('title.procedureTypes', 1),
      url: '/procedureTypes',
      icon: 'far fa-barcode'
    },
    {
      name: i18n.tc('title.procedures', 1),
      url: '/procedures',
      icon: 'far fa-paste'
    },
    {
      name: i18n.tc('title.procedureModels', 1),
      url: '/procedureModels',
      icon: 'far fa-paste'
    },
    {
      name: i18n.tc('title.pendingConsents', 1),
      url: '/pendingConsents',
      icon: 'far fa-paste'
    },
    {
      name: i18n.tc('title.informationConsents', 1),
      url: '/informationConsents',
      icon: 'far fa-paste'
    }
  ]
}
